import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestCreateTags() {
  return {
    type: Constants.REQUEST_CREATE_TAGS
  };
}

export function clearTags() {
  return {
    type: Constants.CLEAR_TAGS
  };
}

export function receiveCreateTags(json, error) {
  return {
    type: Constants.RECEIVE_CREATE_TAGS,
    data: json,
    error
  };
}

export function createTags(image_url, options = {}) {
  const path = 'ecs/api/tag';
  const body = { image_url };

  const payload = JSON.stringify(body);
  return new Endpoint(path, requestCreateTags, receiveCreateTags)
    .withBody(payload)
    .withMethod('POST')
    .withOptions(options)
    .call();
}
